import { NgZone } from '@angular/core';
import { MonoTypeOperatorFunction, Observable } from 'rxjs';

export function runInZone<T>(zone: NgZone): MonoTypeOperatorFunction<T> {
  return observable =>
    new Observable<T>(subscriber =>
      observable.subscribe({
        complete: (...args) => zone.run(subscriber.complete, subscriber, args),
        error: (...args) => zone.run(subscriber.error, subscriber, args),
        next: (...args) => zone.run(subscriber.next, subscriber, args),
      }),
    );
}
